import i18n from 'app/i18n';
import api from '../api';
import config from '../../config';


export const EVENTS_REQUEST = 'EVENTS_REQUEST';
export const EVENTS_SUCCESS = 'EVENTS_SUCCESS';
export const EVENTS_FAILURE = 'EVENTS_FAILURE';

export const EVENT_CHANGE = 'EVENT_CHANGE';
export const EVENT_CHANGE_ALL = 'EVENT_CHANGE_ALL';
export const EVENTS_STATUSES_CHANGE_REQUEST = 'EVENTS_STATUSES_CHANGE_REQUEST';

const eventsRequest = () => ({
  type: EVENTS_REQUEST,
});

const eventsSuccess = data => ({
  type: EVENTS_SUCCESS,
  payload: data,
});

const eventsFailure = errString => ({
  type: EVENTS_FAILURE,
  payload: { err: errString },
});


// Изменение статуса
const setStatus = payload => ({
  type: EVENT_CHANGE,
  payload,
});

// Массовая смена статуса
export const setStatusAll = payload => ({
  type: EVENT_CHANGE_ALL,
  payload,
});

// Смена накопленных статусов, отправка на сервер (редюсером не обрабатывается)
const setStatuses = statuses => ({
  type: EVENTS_STATUSES_CHANGE_REQUEST,
  payload: statuses,
});


/**
* Запрос событий
*/
export const fetchEvents = (id, service, offset = 0, limit = config.maxItemsLoad) =>
  async (dispatch) => {
    const params = {
      offset,
      limit,
    };
    if (id) {
      params.student_id = id;
    }
    if (service !== 'all') {
      params.service = service;
    }
    dispatch(eventsRequest());
    try {
      const res = await api('cabinet/events', 'get', { params });
      dispatch(eventsSuccess({ ...res.data, offset, id: parseInt(id, 10) }));
    } catch (error) {
      dispatch(eventsFailure(i18n.t('app:request_events_failed')));
    }
  };

/**
* Смена статусов всех событий {read: true} с отправкой на сервер
* Запрос поддерживает только смену статусов на 'прочитанно'
*/
export const sendStatusAll = (status, filter) => async (dispatch) => {
  dispatch(setStatusAll({ status, filter }));
  try {
    await api('cabinet/events/read', 'put', {
      // по умолчанию - все, но запрос поддерживает указание конкретного ребенка/пользователя
      data: filter,
    });
  } catch (error) {
    console.log(error, i18n.t('app:request_events_statuses_failed'), error.response);
  }
};

/**
* Смена статусов с накоплением для отправки на сервер. Формат статуса {id: 111, read: true}
* Накопление происходит в течении 200 ms (по умолчанию)
* Запрос поддерживает только смену статусов на 'прочитанно'
*/
let statuses = [];
let timer = null;

export const sendStatus = (status, timeout = 200) => (dispatch) => {
  dispatch(setStatus(status));
  statuses.push(status);

  if (!timer) {
    timer = setTimeout(async () => {
      dispatch(setStatuses(statuses));
      try {
        await api('cabinet/events/read', 'put', {
          data: {
            event_id: statuses.map(st => st.id),
          },
        });
      } catch (error) {
        console.log(error, i18n.t('app:request_events_status_failed'), error.response);
      }
      timer = null;
      statuses = [];
    }, timeout);
  }
};
